import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./messageBox.html";
import { selectShared, WireI18n } from '../../../modules/stores/i18nStore';
import messageBoxTemplate from './messageBox.html';
import messageBoxCardTemplate from './messageBoxCard.html';
import messageBoxNoteTemplate from './messageBoxNote.html';
import messageBoxNotificationTemplate from './messageBoxNotification.html';
class MessageBox extends LightningElement {
  constructor(...args) {
    super(...args);
    this.type = void 0;
    this.message = void 0;
    this.action = void 0;
    this.withoutIcon = void 0;
    this.focused = void 0;
    this.variant = void 0;
    this.noteTitle = void 0;
    this.linkTarget = '_self';
    this.closeCallback = void 0;
    this.indexClose = void 0;
    this.labels = void 0;
  }
  get cssClassNote() {
    return this.focused ? 'note-text-focused' : 'note-text';
  }
  get cssClassBorder() {
    return 'slds-grid slds-grid_vertical ' + (this.focused ? 'grid-border-focused' : 'grid-border');
  }
  get cssClass() {
    return 'message-container ' + this.type;
  }
  get cssNotificationClass() {
    return 'notification-container ' + this.type + ' slds-grid slds-grid_horizontal ';
  }
  get iconName() {
    if (this.variant === 'notification' && this.type === 'success') {
      return 'utility:check';
    }
    return 'utility:' + this.type;
  }
  get iconClass() {
    return 'icon icon-' + this.type;
  }
  get isNewWindow() {
    return this.linkTarget === '_blank';
  }
  render() {
    if (this.variant === 'notification') {
      return messageBoxNotificationTemplate;
    }
    if (this.variant === 'card') {
      return messageBoxCardTemplate;
    }
    return this.type === 'note' ? messageBoxNoteTemplate : messageBoxTemplate;
  }
  /*LWC compiler v7.1.3*/
}
MessageBox.delegatesFocus = true;
_registerDecorators(MessageBox, {
  publicProps: {
    type: {
      config: 0
    },
    message: {
      config: 0
    },
    action: {
      config: 0
    },
    withoutIcon: {
      config: 0
    },
    focused: {
      config: 0
    },
    variant: {
      config: 0
    },
    noteTitle: {
      config: 0
    },
    linkTarget: {
      config: 0
    },
    closeCallback: {
      config: 0
    },
    indexClose: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectShared
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(MessageBox, {
  tmpl: _tmpl,
  sel: "appx-message-box",
  apiVersion: 62
});
export default __lwc_component_class_internal;